module.exports = __webpack_public_path__ + "img/success_icon.dca73968.png";